import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeftOutlined from "@material-ui/icons/ChevronLeftOutlined";
import CloseOutlined from "@material-ui/icons/CloseOutlined";

class SearchField extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.onKeyDown = this.onKeyDown.bind(this);
        this.onSearchValueChange = this.onSearchValueChange.bind(this);

    }

    onSearchValueChange(e) {
        let val = e.target.value;
        this.props.onSearchValueChange(val);
    }

    onKeyDown(e) {
        let key = e.key;
        if (key === 'Enter') {
            this.props.search();
        }
    }

    renderSearchField() {
        return (
            <div className="search-field">
                <ChevronLeftOutlined className="search-back" onClick={this.props.onSearchBackClick} />
                <label htmlFor="searchField"></label>
                <input
                    type="text"
                    className="form-control"
                    id="searchField"
                    placeholder={this.props.placeholder}
                    value={this.props.searchValue}
                    onChange={this.onSearchValueChange}
                    onKeyDown={this.onKeyDown}
                />
                <CloseOutlined className="search-cancel" onClick={this.props.onSearchCancelClick} />
            </div>
        );
    }

    render() {
        return this.renderSearchField();
    }
}

SearchField.propTypes = {
    onSearchBackClick: PropTypes.func.isRequired,
    onSearchCancelClick: PropTypes.func.isRequired,
    onSearchValueChange: PropTypes.func,
    placeholder: PropTypes.string,
    search: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired
};

export default SearchField;
